
import React, { useState, useEffect } from "react";
import Layout from "@/components/layout/Layout";
import { Tabs, TabsContent } from "@/components/ui/tabs";
import FinanceiroTabs from "@/components/financeiro/FinanceiroTabs";
import ResumoTabContent from "@/components/financeiro/tabs/ResumoTabContent";
import ContasTabContent from "@/components/financeiro/tabs/ContasTabContent";
import FluxoTabContent from "@/components/financeiro/tabs/FluxoTabContent";
import RecebimentosTabContent from "@/components/financeiro/tabs/RecebimentosTabContent";
import PagamentosTabContent from "@/components/financeiro/tabs/PagamentosTabContent";
import CadastroTabContent from "@/components/financeiro/tabs/CadastroTabContent";
import { Toaster } from "sonner";
import { format } from "date-fns";
import { pt } from "date-fns/locale";

const FinanceiroDashboard = () => {
  const [periodoSelecionado, setPeriodoSelecionado] = useState(new Date());
  const [tabAtiva, setTabAtiva] = useState("resumo");
  const [showCadastroForm, setShowCadastroForm] = useState(false);
  
  const handleTabChange = (value: string) => {
    setTabAtiva(value);
    setShowCadastroForm(false); // Reset form visibility when changing tabs
  };
  
  useEffect(() => {
    // Listen for the custom event to change the active tab
    const handleCustomTabChange = (event: CustomEvent) => {
      if (event.detail) {
        if (event.detail.tab) {
          setTabAtiva(event.detail.tab);
        }
        
        // Handle specific actions
        if (event.detail.action === 'nova-conta') {
          setShowCadastroForm(true);
        }
      }
    };
    
    window.addEventListener('change-tab', handleCustomTabChange as EventListener);
    
    return () => {
      window.removeEventListener('change-tab', handleCustomTabChange as EventListener);
    };
  }, []);
  
  // Get the URL parameters to see if a specific tab should be activated
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tab = params.get('tab');
    if (tab) {
      setTabAtiva(tab);
    }
  }, []);
  
  return (
    <Layout>
      <div className="container mx-auto p-4 md:p-6 max-w-7xl">
        <div className="flex flex-col mb-6">
          <div className="mb-4">
            <h1 className="text-2xl font-normal text-gray-700 mb-1">Financeiro</h1>
            <p className="text-sm text-gray-500 mt-1 opacity-75">
              Gestão financeira completa para sua empresa
            </p>
          </div>
          <div className="w-full rounded-lg shadow-sm overflow-hidden">
            <FinanceiroTabs 
              tabAtiva={tabAtiva} 
              onChangeTab={handleTabChange} 
              variant="buttons"
              className="overflow-x-auto pb-2 md:pb-0" 
            />
          </div>
        </div>
        
        <Tabs 
          defaultValue="resumo" 
          className="w-full" 
          value={tabAtiva} 
          onValueChange={handleTabChange}
        >
          <TabsContent value="resumo" className="animate-in fade-in-50">
            <ResumoTabContent />
          </TabsContent>
          
          <TabsContent value="contas" className="animate-in fade-in-50">
            <ContasTabContent showCadastroForm={showCadastroForm} onFormVisibilityChange={setShowCadastroForm} />
          </TabsContent>
          
          <TabsContent value="fluxo" className="animate-in fade-in-50">
            <FluxoTabContent periodoSelecionado={format(periodoSelecionado, "MMMM 'de' yyyy", { locale: pt })} />
          </TabsContent>
          
          <TabsContent value="recebimentos" className="animate-in fade-in-50">
            <RecebimentosTabContent />
          </TabsContent>
          
          <TabsContent value="pagamentos" className="animate-in fade-in-50">
            <PagamentosTabContent />
          </TabsContent>
          
          <TabsContent value="cadastro" className="animate-in fade-in-50">
            <CadastroTabContent />
          </TabsContent>
        </Tabs>
        
        <Toaster position="top-right" />
      </div>
    </Layout>
  );
};

export default FinanceiroDashboard;
